export const environment = {
  production: true,
  baseUrl: 'https://memory.marufh.com',
};
